import { TFunction } from 'i18next';
import { UserTopBarMenuTranslations } from '../DesktopTopHeaderBar/subcomponents/UserTopBarMenu/UserTopBarMenu';

export type IMainNavigationTranslations = UserTopBarMenuTranslations & {
  profile: string;
  legalNotice: string;
  reportsAndStatements: string;
  discoverText: string;
  portfolioText: string;
  buttonTransferTopNav: string;
  buySellButtonText: string;
  tradeText: string;
  readOnly: string;
  deposit: string;
  send: string;
  languageTitle: string;
  errorPendingApprovalTransfer: string;
  errorTitleTransfersUnavailable: string;
  goToPortfolio: string;
  germanSubtitle: string;
  englishSubtitle: string;
  arabicSubtitle: string;
  frenchSubtitle: string;
  islamicTitle: string;
  yourAccount: string;
  islamicBankingAccount: string;
  islamicBankingAccountDescription: string;
  islamicBankingAccountLearnMore: string;
};

const mainNavigationTranslations: IMainNavigationTranslations = {
  profile: 'general_profile',
  customerSupport: 'customer_support',
  frequentlyAskedQuestions: 'frequently_asked_questions',
  legalNotice: 'legal_notice',
  generalLogout: 'general_logout',
  termsAndConditions: 'terms_and_conditions',
  twoFaWelcomeTitle: '2fa_welcome_title',
  twoFaResetTitle: '2fa_reset_title',
  reportsAndStatements: 'reports_and_statements',
  legalDocumentation: 'legal_documentation',
  discoverText: 'section_discover',
  portfolioText: 'nav_bar_portfolio',
  buttonTransferTopNav: 'button_transfer_top_nav',
  buySellButtonText: 'button_trade_top_nav',
  tradeText: 'trade_button',
  readOnly: 'user_role_info_read_only',
  deposit: 'deposit',
  send: 'send',
  errorSubtitle: 'info_toast_asset_unavailable_subtitle',
  errorTitle: 'internal_error_headline',
  englishSubtitle: 'select_language_en',
  germanSubtitle: 'select_language_de',
  arabicSubtitle: 'select_language_ar',
  frenchSubtitle: 'select_language_fr',
  languageTitle: 'language',
  errorPendingApprovalTransfer: 'error_message_pending_approval_transfers',
  errorTitleTransfersUnavailable: 'error_title_transfers_unavailable',
  goToPortfolio: 'go_to_portfolio',
  cookies: 'cookies',
  language: 'language',
  accountLevelUpgradeTitle: 'account_level_upgrade_title',
  accountLevelUpgradeSubtitle: 'account_level_upgrade_subtitle',
  islamicTitle: 'islamic_title',
  yourAccount: 'your_account',
  islamicBankingAccount: 'islamic_banking_account',
  islamicBankingAccountDescription: 'islamic_banking_account_description',
  islamicBankingAccountLearnMore: 'islamic_banking_account_learn_more',
};

export const getMainNavigationTranslations = (
  translationUtil: TFunction,
): IMainNavigationTranslations => {
  return Object.entries(mainNavigationTranslations).reduce(
    (acc, [key, value]) => {
      acc[key as keyof IMainNavigationTranslations] = translationUtil(value);

      return acc;
    },
    {} as IMainNavigationTranslations,
  );
};
